import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {BankConnectionStatus} from "../model/statement/autofetch/BankConnectionEnums";
import {StatementDownloadSessionStatusDto} from "../model/statement/autofetch/StatementDownloadSessionStatusDto";

export class WiseConnectionApi {

    public checkStatus(): Promise<{ status: BankConnectionStatus, error?: string }> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/wise/status`, {});
    }

    public fetchStatementProcessingStatus(): Promise<StatementDownloadSessionStatusDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/wise/statement/status`);
    }

    public startStatementDownload(from: Date, to: Date): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/wise/statement/start`, {from, to});
    }

}

export const wiseConnectionApi = new WiseConnectionApi();